<template>
  <div class="form-box">
    <el-form :model="obj" :rules="formRules" ref="sampleForm" label-width="0px" class="order-sample-ruleForm">
      <el-descriptions class="margin-top" :column="6" border>
        <el-descriptions-item :span="3">
          <template slot="label">
            <span class="required"> 申请主体 </span>
          </template>
          <el-form-item label="" prop="ApplySubject">
            <el-input v-model="obj.ApplySubject" placeholder="请输入申请主体">
            </el-input>
          </el-form-item>
        </el-descriptions-item>

        <el-descriptions-item :span="3">
          <template slot="label">
            <span class="required"> 类别 </span></template>
          <el-form-item label="" prop="CategoryCode">
            <el-input v-model="obj.CategoryCode" placeholder="请输入类别">
            </el-input>
          </el-form-item>
        </el-descriptions-item>

        <el-descriptions-item :span="3">
          <template slot="label">
            <span class="required"> 服务类型 </span></template>
          <el-form-item label="" prop="ServiceType">
            <el-select style="width:100%" v-model="obj.ServiceType" placeholder="请选择服务类型" clearable filterable
              popper-class="relative-select" :popper-append-to-body="false">
              <el-option v-for="item in BrandServiceType" :label="item.ItemName" :value="item.ItemValue"> </el-option>
            </el-select>
          </el-form-item>
        </el-descriptions-item>


        <el-descriptions-item :span="3">
          <template slot="label">
            <span class="required"> 国家 </span></template>
          <el-form-item label="" prop="ServiceCountry">
            <el-select style="width:100%" v-model="obj.ServiceCountry" placeholder="请选择国家" clearable filterable
              popper-class="relative-select" :popper-append-to-body="false">
              <el-option v-for="item in CrossBorderServiceCountry" :label="item.ItemName" :value="item.ItemValue">
              </el-option>
            </el-select>
          </el-form-item>
        </el-descriptions-item>

        <el-descriptions-item :span="2">
          <template slot="label"> <span class="required"> 联系人 </span></template>
          <el-form-item label="" prop="Linker">
            <el-input v-model="obj.Linker" placeholder="请输入联系人">
            </el-input>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item :span="2">
          <template slot="label"> <span class="required"> 联系方式 </span></template>
          <el-form-item label="" prop="LinkerPho">
            <el-input v-model="obj.LinkerPho" placeholder="请输入联系方式">
            </el-input>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item :span="2">
          <template slot="label"> <span class="required"> 邮箱 </span></template>
          <el-form-item label="" prop="LinkerEmail">
            <el-input v-model="obj.LinkerEmail" placeholder="请输入邮箱">
            </el-input>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item :span="6">
          <template slot="label"> <span class="required"> 商标类型 </span></template>
          <el-form-item label="" prop="BrandType">
            <el-input v-model="obj.BrandType" placeholder="请输入商标类型">
            </el-input>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item :span="6">
          <template slot="label"> <span class="required"> 商标内容 </span></template>
          <el-form-item label="" prop="BrandName">
            <el-input v-model="obj.BrandName" placeholder="请输入商标内容">
            </el-input>
          </el-form-item>
        </el-descriptions-item>
      </el-descriptions>
    </el-form>
    <div class="msg-box">
      <h4 class="text-error">

      </h4>
    </div>
  </div>
</template>

<script>
import { GetItemDetailList, GetList } from "@/api/general-api"

export default {
  name: 'BrandEdit',
  data() {
    return {
      dialogVisible: false,
      currentRow: null,
      CrossBorderServiceCountry: [],
      BrandServiceType: [],
      expressInformationBoolean: true,
      obj: {
        ApplySubject: null,
        ServiceType: null,
        CategoryCode: null,
        ServiceCountry: null,
        BrandType: null,
        BrandName: null,
        Linker: null,
        LinkerPho: null,
        LinkerEmail: null,
      },
      formRules: {
        ApplySubject: [
          { required: true, message: '请输入申请主体', trigger: 'blur' },
        ],
        ServiceType: [
          { required: true, message: '请选择服务类型', trigger: 'change' },
        ],
        CategoryCode: [
          { required: true, message: '请输入类别', trigger: 'blur' },
        ],
        ServiceCountry: [
          { required: true, message: '请选择国家', trigger: 'change' },
        ],
        BrandType: [
          { required: true, message: '请输入商标类型', trigger: 'blur' },
        ],
        BrandName: [
          { required: true, message: '请输入商标内容', trigger: 'blur' },
        ],
        Linker: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
        ],
        LinkerPho: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
        ],
        LinkerEmail: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          {
            pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: '请输入有效邮箱',
            trigger: 'blur'
          }
        ],
      },
      myAddressList: []
    }
  },
  created() {
    GetItemDetailList({ ItemCode: 'CrossBorderServiceCountry' }).then(res => {
      if (res.success) {
        this.CrossBorderServiceCountry = res.data
      }
    })
    GetItemDetailList({ ItemCode: 'BrandServiceType' }).then(res => {
      if (res.success) {
        this.BrandServiceType = res.data
      }
    })
    this.handleGetList()
  },
  methods: {
    onAddressTableRowClick(row) {
      this.currentRow = row;
    },
    OnOpenAddressList() {
      this.dialogVisible = true;
    },
    onArressSelected() {
      if (!this.currentRow) {
        return this.$message.error("请先选择一行地址信息！");
      }

      this.obj.BackLinker = this.currentRow.Linker
      this.obj.BackLinkTel = this.currentRow.LinkTel
      this.obj.BackAddress = this.currentRow.Address
      this.dialogVisible = false;
    },
    GetData() {
      let _b = true
      this.$refs.sampleForm.validate((valid) => {
        _b = _b && valid
      })
      if (_b) {
        return { ...this.obj }
      }
    },
    handleGetList() {
      const queryParam = {
        Name: 'UserAddress',
        currentPage: 1,
        pageSize: 999,
        orderField: 'CreateTime',
        orderType: 'descend'
      }
      GetList(queryParam).then((res) => {
        if (res.success) {
          this.myAddressList = res.data.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
  },

}
</script>

<style lang="scss">
.el-dialog.address-select-wnd {
  margin-top: 20vh !important;
}

.form-box {
  padding: 0px;
}

.order-sample-ruleForm {
  .el-form-item {
    margin-bottom: 12px!important;
  }

  .el-descriptions-item__cell {
    padding: 0px 5px !important;
  }

  .required {
    &::after {
      content: "*";
      color: #c10015;
      font-size: 20px;
      font-weight: bold;
    }
  }
}

.msg-box {
  margin: 30px 0;
  padding: 10px 20px;
  background: #f0f0f0;
}
</style>